import React from 'react';
import { AboutMe } from '../AboutMe/AboutMe';
import { Prices } from '../Prices/Prices';
import { ProjectList } from '../ProjectList/ProjectList';
import { Services } from '../Services/Services';

export const HomePage = ({
  headerHeight,
  showCards,
}: {
  headerHeight: number;
  showCards: (num: number) => void;
}) => {
  return (
    <>
      <ProjectList headerHeight={headerHeight} handleShowedCards={showCards} />
      <AboutMe />
      <Services />
      <Prices />
    </>
  );
};
